import { type Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
	if (process.env.NODE_ENV !== "production") return;

	const captureWebVitals = (metric: Metric) => {
		if (onPerfEntry && onPerfEntry instanceof Function) {
			onPerfEntry(metric);
		}
	};

	onCLS(captureWebVitals);
	onFCP(captureWebVitals);
	onLCP(captureWebVitals);
	onTTFB(captureWebVitals);
	onINP(captureWebVitals);
};

export default reportWebVitals;
